import React, { useContext, useEffect } from "react";
import { useTranslation } from "@me8eon/translation";
import { extractNewAiSource, LikeOrDislike, useFeedback } from "@me8eon/feedback";
import { FeedbackButton } from "../atoms/FeedbackButton";
import { AiAssistContext, useAiAssistContext } from "../../../components/ai-assist-refactored/AiAssist.context";
import { useUserData } from "@me8eon/react_authentication";
import { useMessages } from "@me8eon/sessions_messages";
import { getSources } from "../../../util/message-utils";

type Props = {
    setSelected: (type: LikeOrDislike) => void
    selected: LikeOrDislike | undefined
    isFeedbackSend: boolean
    getLastObj: (val: string) => string
}

export const FeedbackOptions = (props: Props) => {
    const { setSelected, selected, isFeedbackSend, getLastObj } = props;
    const feedback = useFeedback();
    const { currentAgent } = useContext(AiAssistContext);
    const t = useTranslation();
    const [messages] = useMessages();

    const { company, currentRole } = useUserData();
    const { actualMessages } = useAiAssistContext();

    async function dataToSend(likeDislike: LikeOrDislike | undefined) {
        const aiResp = getLastObj("assistant");
        const payload: any = ({
            source: "ai-assist",
            like: likeDislike,
            messages: actualMessages,
            classification: { category: currentAgent || "NA" },
            query: getLastObj("user"),
            answer: aiResp,
            sourceFromAnswer: extractNewAiSource(aiResp),
            sources: getSources(messages),
            company: company || "unknown",
            role: currentRole || "unknown",
        });
        return payload;
    }

    useEffect(() => {
        const callLikeDislike = async () => {
            await feedback(await dataToSend(selected));
        }
        selected && callLikeDislike();
    }, [selected])

    return (
        <div className="feedback">
            <div className="record-feedback">
                <span className="title">{t("chatBot.feedbackTitle")}</span>
                <FeedbackButton
                    type={"like"}
                    value={selected}
                    onClick={() => setSelected('like')}
                    disabled={false}
                />
                <FeedbackButton
                    type={"dislike"}
                    value={selected}
                    onClick={() => setSelected('dislike')}
                    disabled={false}
                />
            </div>
        </div>
    )
}